import React, { ComponentType, useState } from "react";
import { ViewerProps } from "../../viewer-context/withViewer";

export interface BasicFormattingProps {
  fitToHeight: () => void;
  fitToWidth: () => void;
  increaseZoom: () => void;
  decreaseZoom: () => void;
  setZoomScale: (zoomLevel: number) => void;
  zoomLevel: number;
  setDps: (on: boolean) => void;
  twoPageSpread: boolean;
}

export default function withFormatting<
  P extends BasicFormattingProps & ViewerProps
>(
  Component: ComponentType<P>
): ComponentType<Omit<P, keyof BasicFormattingProps>> {
  return function ComponentWithFormatting(props) {
    const [zoomLevel, setZoomLevel] = useState(1);
    const [twoPageSpread, setTwoPageSpread] = useState(false);

    const viewer = props.viewer;
    const book = viewer.Book;

    const updateZoomScale = () => {
      book.getZoomScale(r => {
        setZoomLevel(r.data.zoomScale);
      });
    };

    const setZoomScale = (zoomLevel: number) => {
      book.setZoomScale(zoomLevel);
      updateZoomScale();
    };

    const increaseZoom = () => {
      book.increaseZoomScale();
      updateZoomScale();
    };

    const decreaseZoom = () => {
      book.decreaseZoomScale();
      updateZoomScale();
    };

    const fitToWidth = () => {
      setZoomScale(1);
      book.fitToWidth();
    };

    const fitToHeight = () => {
      setZoomScale(1);
      book.fitToHeight();
    };

    const setDps = (on: boolean) => {
      viewer.Viewport.setDPS(on);
      setTwoPageSpread(on);
    };

    return (
      <Component
        {...(props as P)}
        twoPageSpread={twoPageSpread}
        setZoomScale={setZoomScale}
        zoomLevel={zoomLevel}
        fitToWidth={fitToWidth}
        fitToHeight={fitToHeight}
        increaseZoom={increaseZoom}
        decreaseZoom={decreaseZoom}
        setDps={setDps}
      />
    );
  };
}
